import axios from "axios";

const state = () => ({
    isBusy: false,
})

// getters
const getters = {
    isBusy: state => state.isBusy,
}

// mutations
const mutations = {
    setBusy(state, data) {
        state.isBusy = data;
    }
}

// actions
const actions = {
    // eslint-disable-next-line no-unused-vars
    manualCredit({state, commit}, payload) {
        commit('setBusy', true);
        return new Promise((resolve, reject) => {
            axios.post(`/api/manual-credit/tenant`, payload)
                .then(resp => {
                    commit('setBusy', false);
                    resolve(resp.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
